/**
 * Stimulus Setup
 * Configures Stimulus application with lazy loading for WWW site
 */

import { Application } from '@hotwired/stimulus';
import enableStimulusLazyLoad from 'common/stimulus_lazy_loader';

// =============================================================================
// CRITICAL CONTROLLERS - Pre-loaded, not lazy loaded
// =============================================================================
// Navigation controller must be preloaded because it's on every page and needs
// to be ready immediately for proper Turbo navigation handling.
// =============================================================================

// Widget controllers
import tooltipController from '../../../../app/javascript/controllers/tooltip_controller.js';
// Navigation controller (single controller for entire navbar - no Bootstrap)
import navbarController from '../../../../app/javascript/controllers/navbar_controller.js';

// Create and start Stimulus application
const application = Application.start();
application.debug = false;

// Expose globally for lazy loader and debugging
window.Stimulus = application;

// Register critical controllers immediately (not lazy loaded)
// Widgets
application.register('tooltip', tooltipController);
// Navigation (on every page in navbar)
application.register('navbar', navbarController);

// Mark as loaded in the lazy loader's tracking Set to prevent re-registration
const preloadedControllers = [
  'tooltip',
  'navbar'
];
if (window.__loadedStimulusIds) {
  preloadedControllers.forEach(id => window.__loadedStimulusIds.add(id));
} else {
  window.__loadedStimulusIds = new Set(preloadedControllers);
}

// Enable lazy loading for all other controllers (carousel, popover, etc.)
enableStimulusLazyLoad(application);

export { application };
